import { Component, OnInit, Inject, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CabinetsService } from '../../data/cabinets.service';
import { Cabinet } from '../../data/cabinet';
import { trackEntityById, API_URL } from 'projects/core/src/public-api';
import { ProjectService } from '../../../project-misc/data/project/project.service';
import { Project } from '../../../project-misc/data/project/project';
import { ProjectStatus } from '../../../project-misc/data/project/statuses/project-status';
import { ProjectActivityStatus } from '../../../project-misc/utils/project.utils';
import { timer, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ProjectFile } from '../../../project-misc/data/project/project-file';
import { MatSnackBarRef, SimpleSnackBar, MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationService } from 'primeng/api';
import { MvcExceptionResponse } from 'projects/core/src/lib/core/data/mvc-exception-response';
import {
  LabelsPrintDialogComponent
} from '../../../project-misc/view/project-panel/labels-print-dialog/labels-print-dialog.component';
import { HiddenCabinetsDialogComponent } from '../hidden-cabinets-dialog/hidden-cabinets-dialog.component';
import { PunchListDialogComponent } from '../punch-list-dialog/punch-list-dialog.component';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Cart } from 'projects/cart-tv/src/app/data/cart';
import { CartsService } from 'projects/cart-tv/src/app/data/cart.sevice';
import { Part } from 'projects/cart-tv/src/app/data/parts/part';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { PartGroup } from 'projects/cart-tv/src/app/data/parts/part-group';


@Component({
  selector: 'app-toggle-cabinets-status',
  templateUrl: './toggle-cabinets-status.component.html',
  styleUrls: ['./toggle-cabinets-status.component.scss'],
  providers: [DeviceDetectorService, ConfirmationService]
})
@RxJSUnsubscribe
export class ToggleCabinetsStatusComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
  project: Project;

  cabinets: Cabinet[]

  partGroups: PartGroup[];

  cabinetsIsLoading: boolean;

  trackEntityById = trackEntityById;

  header: string;

  statusName: string;

  activityStatus: ProjectActivityStatus;

  activityType: string

  statuses: ProjectStatus[];
  status: ProjectStatus;
  booleanString: string;
  activityString: string;

  scanLoading: boolean;

  showLoadingSpinner = false;
  showPdf = false;

  blobUrl: any;

  isMobile = false;
  isDesktop = false;
  foundedDrawing: ProjectFile;

  showBarcodeScanner = false;

  prevCabinet: HTMLElement;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  pageToShow = 1;

  showDrawing = false;

  selectedCart: Cart;
  selectedCartToShow: Cart;

  showAddInput = false;
  newCabLoading = false;
  newCabinetDesc: string;
  newCabinetName: string;

  showParts = false;

  hidingMode = false;

  clearHideConfirmations = false;

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    private dialog: MatDialog,
    protected cabinetsService: CabinetsService,
    private miscSnackBarService: MiscSnackBarService,
    protected confirmationService: ConfirmationService,
    protected projectService: ProjectService,
    protected el: ElementRef,
    protected deviceDetectorService: DeviceDetectorService,
    private cartService: CartsService,
    private http: HttpClient, // TODO MOVE TO SERVICE
    @Inject(MAT_DIALOG_DATA) private data: {
      project: Project,
      activityType: string
      activityStatus: ProjectActivityStatus,
      cartId?: number
    }
  ) {
    this.project = this.data.project;

    if(this.data.activityType === 'assembly') {
      this.header = 'Assembly';
      this.statusName = 'Assembled';
      this.booleanString = 'assemblyReady';
      this.activityString = 'Assembled';
    } else if(this.data.activityType === 'qualityControl') {
      this.header = 'Quality Control';
      this.statusName = 'QC passed';
      this.booleanString = 'qualityControlReady';
      this.activityString = 'QC passed';
    } else if(this.data.activityType === 'finishingSubmit') {
      this.header = 'Finishing Submit';
      this.statusName = 'Finishing Submitted';
      this.booleanString = 'finishingReady';
      this.activityString = 'Finishing Submitted';
      this.showParts = true;
    } else if(this.data.activityType === 'jobDelivery') {
      this.header = 'Delivery';
      this.statusName = 'Delivered';
      this.booleanString = 'jobDeliveryReady';
      this.activityString = 'Delivered';
    } else if(this.data.activityType === 'clientPickup') {
      this.header = 'Client Pickup';
      this.statusName = 'Delivered';
      this.booleanString = 'jobDeliveryReady';
      this.activityString = 'Delivered';
    }
    this.activityStatus = this.data.activityStatus
    this.activityType = this.data.activityType;


    this.isMobile = this.deviceDetectorService.isMobile();
    this.isDesktop = this.deviceDetectorService.isDesktop();

    if(!this.isMobile) {
      this.projectService.getProjectFiles(this.project.id).pipe(
        takeUntil(this.getUnsubFromAllSubs())
      ).subscribe(files => {
        this.project.files = files;

        this.foundedDrawing = this.project.files.find(file => file.clazz === 'CV_PROJECT_DRAWING_FILE');

        if(this.data.cartId && this.project.carts) {
          this.selectedCart = this.project.carts.find(cart => cart.id === this.data.cartId)

          if(this.selectedCart) {
            this.cartChanged()
          }
        } else if(this.foundedDrawing) {
          this.toggleDrawing()
        }

      })
    }
  }

  addCabinet() {
    this.showAddInput = true;
    timer(1).subscribe(emit => {
      const upperInputs: HTMLInputElement[] = this.el.nativeElement.getElementsByClassName('cab-input-field');
      upperInputs[0].focus()
    })
  }

  createCabinet() {
    const tempCab = {
      id: null,
      cabinetName: this.newCabinetName,
      description: this.newCabinetDesc,
      createdManually: true
    } as Cabinet

    this.newCabLoading = true;

    let createService = this.cabinetsService.createCabinets(this.project.id, tempCab)

    if(this.showParts) {
      createService = this.cartService.createPart(this.project.id, tempCab as Part)
    }

    createService.subscribe(newCab => {
      this.newCabLoading = false;
      if(this.showParts) {
        const part = newCab as any

        this.cabinets.push({
          id: part.id,
          cabinetId: part.cabinet.id,
          cabinetName: part.cabinet.cabinetName,
          description: part.description,
          createdManually: true
        })
      } else {
        this.cabinets.push(newCab)
      }
      this.closeInput()
    }, error => {

    })

  }

  deleteCabinet(index: number) {
    let service = this.cabinetsService.deleteCabinet(this.cabinets[index].id);

    if(this.showParts) {
      service = this.cartService.deletePart(this.cabinets[index].id)
    }

    service.subscribe(emit => {
      this.cabinets.splice(index, 1)
    })
  }

  closeInput() {
    this.showAddInput = false;
    this.newCabinetDesc = ''
    this.newCabinetName = ''
  }

  foundDrawings(url) {

    this.showLoadingSpinner = true;
    // timer(5000).subscribe(emit => {
    this.downloadFile(url).pipe(
      takeUntil(this.getUnsubFromAllSubs())
    ).subscribe(
      (res) => {
        this.blobUrl = res;

        this.showLoadingSpinner = false;
        this.showPdf = true;
      },
      error => {
        this.foundedDrawing = null;
        this.showLoadingSpinner = false;
        this.showPdf = false;
      }
    );
  }

  private downloadFile(url: string): any {
    return this.http.get(url, {responseType: 'blob'})
    .pipe(
      map((result: any) => {
        return result;
      })
    );
  }


  ngOnInit(): void {
    this.loadCabinets();

    this.getCabinetStatuses();
  }

  getCabinetStatuses() {
    this.cabinetsService.getCabinetStatuses().pipe(
      takeUntil(this.getUnsubFromAllSubs())
    ).subscribe(statuses => {
      this.statuses = statuses;
      this.status = this.statuses.find(status => status.name === this.statusName);
    })
  }

  toggleActivityReady() {
    this.activityStatus.ready = !this.activityStatus.ready;

    this.projectService
    .toggleActivity(this.project, this.data.activityType, this.activityStatus.ready).pipe(
      takeUntil(this.getUnsubFromAllSubs())
    )
    .subscribe(otvet => {

    }, error => {
      if(error instanceof MvcExceptionResponse) {
        this.activityStatus.ready = !this.activityStatus.ready;
      }
    })

    if(this.data.activityType === 'qualityControl' && this.activityStatus.ready) {

      let undoneCabs = 0;
      this.cabinets.forEach(cab => {
        undoneCabs += !cab.qualityControlReady ? 1 : 0
      });


      if(undoneCabs) {
        const dialogRef = this.dialog.open(PunchListDialogComponent, {
          data: { projectId: this.project.id },
          maxHeight: '80vh',
          disableClose: false,
          panelClass: 'punch-list-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
          this.loadCabinets();
        });
      }
    }
  }

  toggleCabinetStatus(cabinet: Cabinet) {
    let saveService = this.cabinetsService.saveCabinet(cabinet)

    if(this.showParts) {
      saveService = this.cartService.savePart(cabinet as Part)
    }

    cabinet[this.booleanString] = !cabinet[this.booleanString]

    saveService.pipe(
      takeUntil(this.getUnsubFromAllSubs())
    )
    .subscribe(cab => {
      if(cabinet[this.booleanString]) {
        this.project[this.activityType + 'CabinetsDone']++;
      } else {
        this.project[this.activityType + 'CabinetsDone']--;
      }
    }, error => {
      cabinet[this.booleanString] = !cabinet[this.booleanString]
    })
  }

  loadCabinets() {
    this.cabinetsIsLoading = true;

    if(this.showParts) {
      this.cartService.getFinishingParts(this.project.id).pipe(
        takeUntil(this.getUnsubFromAllSubs())
      ).subscribe(partGroups => {
        this.partGroups = partGroups
        this.cabinetsIsLoading = false;
      })
    } else {
      this.cabinetsService.getCabinets(this.project.id).pipe(
        takeUntil(this.getUnsubFromAllSubs())
      ).subscribe(cabinets => {
        this.cabinets = cabinets
        this.cabinetsIsLoading = false;
      })
    }
  }

  successScan(cabinet?: Cabinet) {
    const cabIndex = cabinet.cabinetId
    // const cabIndex = 88

    const scrollElems: HTMLElement[] = this.el.nativeElement.getElementsByClassName('cabinets-middle-content');
    const scrollEl: HTMLElement = scrollElems[0]
    const cabBlocks = this.el.nativeElement.getElementsByClassName('cabinet-block')

    // todayElems[0].scrollIntoView()
    if(cabBlocks.length > 10) {

      setTimeout(() => {

        const target = cabBlocks[cabIndex] as HTMLElement;

        scrollEl.scrollTo({top: target.offsetTop - 350, behavior: 'smooth'});

        if(this.prevCabinet) {
          this.prevCabinet.classList.remove('HIGHLIGHT-CAB');
        }

        timer(500).pipe(
          takeUntil(this.getUnsubFromAllSubs())
        ).subscribe(() => {
          cabBlocks[cabIndex].classList.add('HIGHLIGHT-CAB');
        })

        this.prevCabinet = cabBlocks[cabIndex];
      }, 1)

    }

    const fCab = this.cabinets.find(cab => cab.id === cabinet.id);
    if(!fCab[this.booleanString]) {
      this.project[this.activityType + 'CabinetsDone']++;
    }

    if(fCab) {
      this.miscSnackBarService.openSuccessSnackBar('#' + cabinet.cabinetId + ' ' + cabinet.cabinetName + ' Scanned!', 5000)
    } else {
      this.miscSnackBarService.openWarningSnackBar('#' + cabinet.cabinetId + ' ' + cabinet.cabinetName + ' Scanned!', 5000)
    }

    fCab[this.booleanString] = true;
  }

  successScanTest(num: number) {
    const cabIndex = num
    // tslint:disable-next-line: radix
  }


  printLabels() {
    this.scanLoading = true;

    const dialogRef = this.dialog.open(LabelsPrintDialogComponent, {
      data: {
        id: this.project.id,
        name: this.project.name
      },
      panelClass: 'labels-modal-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      this.scanLoading = false;

      if(result === 'Success!') {
        this.miscSnackBarService.openSuccessSnackBar('Success!')
      }
    });
  }

  toggleCamera() {
    this.showBarcodeScanner = !this.showBarcodeScanner
  }

  scrollToFile(cabinet: Cabinet) {
    this.resetCart()

    if(this.showDrawing) {
      const url = this.apiUrl + `/project/${this.project.id}/files/last-assembly-sheet`
      this.foundDrawings(url);
    }

    this.showDrawing = false;

    if (cabinet.page !== null && cabinet.page !== undefined) {
      this.pageToShow = cabinet.page
    } else {
      this.pageToShow = cabinet.cabinetId * 2
    }
  }

  toggleDrawing() {
    this.resetCart()

    if(!this.showDrawing && this.foundedDrawing) {
      const url = this.apiUrl + `/project/${this.project.id}/files/${this.foundedDrawing.id}`
      this.foundDrawings(url);
    }

    this.pageToShow = 1;

    this.showDrawing = true;
  }

  resetCart() {
    this.selectedCart = null;
    this.selectedCartToShow = null;
  }

  ngOnDestroy() {

  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  cartChanged() {
    this.showLoadingSpinner = true;
    this.cartService.getCart(this.selectedCart.id).subscribe(cart => {
      this.selectedCartToShow = cart;
      this.showLoadingSpinner = false;
    })
  }

  toggleHidingMode() {
    this.hidingMode = !this.hidingMode;
    this.clearHideConfirmations = !this.clearHideConfirmations;
  }

  hideCabinet(cabinet: Cabinet) {
    this.cabinetsService.addIgnoredCabinet(cabinet.cabinetName).pipe(
      takeUntil(this.getUnsubFromAllSubs())
    ).subscribe(() => {
      this.cabinets = this.cabinets.filter(c => c.cabinetName !== cabinet.cabinetName);
      this.miscSnackBarService.openSuccessSnackBar('Cabinet hidden successfully');
    }, error => {
      this.miscSnackBarService.openErrorSnackBar('Failed to hide cabinet');
    });
  }

  openHiddenCabinetsDialog() {
    const dialogRef = this.dialog.open(HiddenCabinetsDialogComponent, {
      data: { projectId: this.project.id },
      maxHeight: '80vh',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
        this.hidingMode = false;
        this.clearHideConfirmations = false;
        this.loadCabinets();
    });
  }
}
